<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="name"
          label="分类名称"
        >
          <a-input placeholder="请输入分类名称" v-model="model.name" />
        </a-form-model-item>
        <!--        <a-form-model-item-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--          prop="parentId"-->
        <!--          label="0表示一级分类，其他值对应父分类ID"-->
        <!--        >-->
        <!--          <a-input-number v-model="model.parentId" />-->
        <!--        </a-form-model-item>-->
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="level"
          label="1-一级分类 2-二级分类"
        >
          <a-input-number placeholder="请输入1-一级分类 2-二级分类" v-model="model.level" />
        </a-form-model-item>
        <!--        <a-form-model-item-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--          prop="isFinal"-->
        <!--          label="1-末级分类（可关联文章） 0-非末级"-->
        <!--        >-->
        <!--          <a-input-number-->
        <!--            placeholder="请输入1-末级分类（可关联文章） 0-非末级"-->
        <!--            v-model="model.isFinal"-->
        <!--            style="width: 100%"-->
        <!--          />-->
        <!--        </a-form-model-item>-->
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="sort"
          label="排序值（越小越靠前）"
        >
          <a-input-number v-model="model.sort" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import moment from 'moment'

export default {
  name: 'ArticleCategoryModal',
  data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },

      confirmLoading: false,
      validatorRules: {
        name: [{ required: true, message: '请输入分类名称!' }],
        level: [{ required: true, message: '请输入1-一级分类 2-二级分类!' }],
      },
      url: {
        add: '/articleCategory/add',
        edit: '/articleCategory/edit',
      },
    }
  },
  created() {},
  methods: {
    add() {
      //初始化默认值
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.clearValidate()
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-input-number {
  width: 100% !important;
}
</style>
